import type { CSVObj } from "@/types"
import type { Channel } from "@/utils/fileImport/channels"
import { incrementLastCharacter } from "@/utils"
import { ALPHA_QUANTITY_SOLD, ALPHA_VARIANT_ID } from "@/utils/alphaModel"

export const headers = [
  [
    "Sale Date",
    "Item Name",
    "Buyer",
    "Quantity",
    "Price",
    "Coupon Code",
    "Coupon Details",
    "Discount Amount",
    "Shipping Discount",
    "Order Shipping",
    "Order Sales Tax",
    "Item Total",
    "Currency",
    "Transaction ID",
    "Listing ID",
    "Date Paid",
    "Date Shipped",
    "Ship Name",
    "Ship Address1",
    "Ship Address2",
    "Ship City",
    "Ship State",
    "Ship Zipcode",
    "Ship Country",
    "Order ID",
    "Variations",
    "Order Type",
    "Listings Type",
    "Payment Type",
    "InPerson Discount",
    "InPerson Location",
    "VAT Paid by Buyer",
    "SKU",
  ],
  [
    "Sale Date",
    "Item Name",
    "Buyer",
    "Quantity",
    "Price",
    "Coupon Code",
    "Coupon Details",
    "Discount Amount",
    "Shipping Discount",
    "Order Shipping",
    "Order Sales Tax",
    "Item Total",
    "Currency",
    "Transaction ID",
    "Listing ID",
    "Date Paid",
    "Date Shipped",
    "Ship Name",
    "Ship Address1",
    "Ship Address2",
    "Ship City",
    "Ship State",
    "Ship Zipcode",
    "Ship Country",
    "Order ID",
    "Variations",
    "Order Type",
    "Listings Type",
    "Payment Type",
    "InPerson Discount",
    "InPerson Location",
    "VAT Paid by Buyer",
    "SKU",
    "Item Sold (Item Name + Variations)", // Generated columns by formatter method
  ],
]

const channel: Channel = {
  headers,
  dateFormats: {
    Date: "MDY",
  },
  blockMap: {
    [ALPHA_QUANTITY_SOLD]: {
      target: "Quantity",
      columns: {
        [ALPHA_VARIANT_ID]: "Item Sold (Item Name + Variations)",
        Date: "Sale Date",
      },
      notInFile: {
        Channel: "Etsy",
      },
    },
  },
  formatter: (csv: CSVObj) => {
    const column1Index = csv.headers.findIndex(
      (header) => header === "Item Name"
    )
    const column2Index = csv.headers.findIndex(
      (header) => header === "Variations"
    )

    const appendedHeader = `Item Sold (Item Name + Variations)`

    csv.headers.push(appendedHeader)

    const lastSheetHeader = csv.sheetHeaders[csv.sheetHeaders.length - 1]

    // Add to the sheet headers letters, we need to do this because we store the
    // headers when the file is uploaded instead of generating when rendered in a table.
    csv.sheetHeaders.push(incrementLastCharacter(lastSheetHeader))

    // Add a new column to each row.
    for (let i = 0; i < csv.rows.length; i++) {
      const row = csv.rows[i]
      const newColumn = `${row[column1Index]} (${row[column2Index]})`
      csv.rows[i].push(newColumn)
    }

    return csv
  },
}

export default channel
